export default __webpack_public_path__ + "static/media/Xmeme-sm.971149af.png";